import React from "react";
import { useNavigate } from "react-router-dom";

import "../Styles/index.css";

import LayoutComunicacion from "./comunicacion/LayoutComunicacion";

export default function IntranetComunicacionDocumentosPage() {
    const navigate = useNavigate();

    const handleNavigate = (target, item = null) => {
        navigate(`/menu/intranet/comunicacion/${target}`, { state: { initialItem: item } });
    };

    return (
        <LayoutComunicacion activeScreen="gestorDocumentos" onNavigate={handleNavigate} />
    );
}
